import { Box, Typography } from '@mui/material';
import { isValid } from 'date-fns';
import React from 'react';
import { DateTimePicker } from '../DateTimePicker';
export const DateTimeRangePicker = (props) => {
    const fromValue = getDateTimeValue(props.value.fromDate, props.value.fromValue);
    const toValue = getDateTimeValue(props.value.toDate, props.value.toValue);
    const handleFromChange = (newFromValue) => {
        props.onChange({
            fromDate: newFromValue.date,
            toDate: toValue.date,
            fromValue: newFromValue,
            toValue: toValue,
        });
    };
    const handleToChange = (newToValue) => {
        props.onChange({
            fromDate: fromValue.date,
            toDate: newToValue.date,
            fromValue: fromValue,
            toValue: newToValue,
        });
    };
    const rootSx = {
        display: 'inline-flex',
        gap: props.separatorLabel ? 1 : 2,
        flexWrap: 'wrap',
        justifyContent: {
            xs: 'center',
            sm: 'flex-start',
        },
    };
    const childSx = {
        flexBasis: { xs: '100%', sm: 0 },
        flexGrow: 1,
        maxWidth: {
            xs: '100%',
            sm: props.fullWidth ? '100%' : 536,
        },
        flexDirection: {
            xs: 'column',
            sm: 'row',
        },
    };
    if (props.fullWidth) {
        rootSx.width = '100%';
    }
    return (React.createElement(Box, { sx: Object.assign(Object.assign({}, rootSx), props.sx), "data-test": 'date-time-range-picker' },
        React.createElement(DateTimePicker, { sx: childSx, dateLabel: props.fromDateLabel, timeLabel: props.fromTimeLabel, minDate: props.minDate, maxDate: pickSmallerDate(toValue.date, props.maxDate), timeFormat: props.timeFormat, timeMinuteStep: props.timeMinuteStep, required: props.required, disabled: props.disabled, readOnly: props.readOnly, fullWidth: props.fullWidth, size: props.size, error: props.error, dateTabIndex: props.fromDateTabIndex, timeTabIndex: props.fromTimeTabIndex, value: fromValue, onChange: handleFromChange, "data-test-date": 'from-date-picker', "data-test-time": 'from-time-picker', autoFocus: props.autoFocus, ariaDescribedBy: props.ariaDescribedBy }),
        props.separatorLabel && (React.createElement(Typography, { component: 'div', sx: {
                my: 2,
                mx: {
                    xs: 0,
                    sm: 1,
                },
            } }, props.separatorLabel)),
        React.createElement(DateTimePicker, { sx: childSx, dateLabel: props.toDateLabel, timeLabel: props.toTimeLabel, minDate: pickLargerDate(fromValue.date, props.minDate), maxDate: props.maxDate, timeFormat: props.timeFormat, timeMinuteStep: props.timeMinuteStep, required: props.required, disabled: props.disabled, readOnly: props.readOnly, fullWidth: props.fullWidth, size: props.size, error: props.error, dateTabIndex: props.toDateTabIndex, timeTabIndex: props.toTimeTabIndex, value: toValue, onChange: handleToChange, "data-test-date": 'to-date-picker', "data-test-time": 'to-time-picker', ariaDescribedBy: props.ariaDescribedBy })));
};
function getDateTimeValue(date, value) {
    if (value) {
        return value;
    }
    else if (date) {
        if (isValid(date)) {
            return { date };
        }
        else {
            return { dateValue: { invalidDate: date } };
        }
    }
    else {
        return {};
    }
}
function pickSmallerDate(a, b) {
    if (a && b) {
        return a.getTime() < b.getTime() ? a : b;
    }
    else if (a) {
        return a;
    }
    else if (b) {
        return b;
    }
    else {
        return undefined;
    }
}
function pickLargerDate(a, b) {
    if (a && b) {
        return a.getTime() > b.getTime() ? a : b;
    }
    else if (a) {
        return a;
    }
    else if (b) {
        return b;
    }
    else {
        return undefined;
    }
}
